module.exports = __webpack_public_path__ + "img/6.0afd606d.jpg";